import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Cart } from '../view-products/cart.model';
import { AppConstant } from '../AppConstant';
@Injectable({
  providedIn: 'root'
})
export class ViewProductService {

  constructor(private httpClient : HttpClient) { }

  
  Add_Customer_Details_URL= 'cart/addCart';
  DeleteFromCart_URL='deleteCart/';

  AddToCart(product: any){
    console.log("In service");
    console.log(AppConstant.baseURL + this.Add_Customer_Details_URL);
    return this.httpClient.post(AppConstant.baseURL + this.Add_Customer_Details_URL,product)
  }

  DeleteFromCart(cartId:number){
    console.log("In delete service");
    console.log(AppConstant.baseURL + this.DeleteFromCart_URL + cartId);
    return this.httpClient.delete(AppConstant.baseURL + this.DeleteFromCart_URL + cartId)
  }
}
